import { net_common } from "@/api/http";
export const API_Import = (...params) =>
  net_common.post("/api/STDSDC01C05/Import", ...params);
